module.exports = __webpack_public_path__ + "static/media/lal-logo.e2d71726.png";